// extracted by mini-css-extract-plugin
export var modal = "_t6-0";
export var table = "_t6-1";